import client from './client';

/**
 * 크리에이티브 통계리스트
 */
export const creativeList = (params) =>
  client.get(`/api/ch_report/creative`, params);

/**
 * 크리에이티브 통계리스트 - 미리보기
 */
export const creativeListFreeView = (params) =>
  client.get(`/api/ch_report/creative/freeView`, params);

/**
 * 크리에이티브 통계리스트 - abTest 리스트
 */
export const creativeListAbTest = (params) =>
  client.get(`/api/ch_report/creative/abTest`, params);

/**
 * 크리에이티브 통계리스트 - 품질지수 현황판
 */
export const creativeListQltyBoard = (params) =>
  client.get(`/api/ch_report/creative/qltyBoard`, params);

/**
 * 크리에이티브 통계리스트 - 그룹 연결 리스트
 */
export const creativeListDetail = (params) =>
  client.get(`/api/ch_report/creative/detail`, params);
